import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import collections from '../constants/FirestoreCollections';

export default function useChat() {
  const firestore = useFirestore();
  const chatId = useSelector((state) => state.app.activeChat);
  const [unsubscribers, setUnsubscribers] = useState([]);
  const [chat, setChat] = useState();

  useEffect(() => {
    if (unsubscribers.length > 1) {
      unsubscribers.forEach((unsubscribe, index) => {
        if (index !== unsubscribers.length - 1) unsubscribe();
      });
      setUnsubscribers((oldData) => [oldData[oldData.length - 1]]);
    }
  }, [unsubscribers]);

  // empty message if active chat changed
  useEffect(() => {
    const unsubscribe = firestore
      .collection(collections.chats)
      .doc(chatId)
      .onSnapshot((snapshot) => {
        setChat(snapshot.data());
      });

    setUnsubscribers((old) => [...old, unsubscribe]);
    return () => {
      unsubscribe && unsubscribe();
    };
  }, [chatId, firestore]);

  return chat;
}
